import { render, staticRenderFns } from "./Vencimento.vue?vue&type=template&id=19c3ab05&scoped=true"
import script from "./Vencimento.vue?vue&type=script&lang=js"
export * from "./Vencimento.vue?vue&type=script&lang=js"
import style0 from "./Vencimento.vue?vue&type=style&index=0&id=19c3ab05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c3ab05",
  null
  
)

export default component.exports